module.exports = __webpack_public_path__ + "static/media/toon3.793400ec.png";